import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleOne, StyleTwo } from '../components/RelatedSCard';

class WealthManagement extends Component {
    render() {
        return (
            <div className='service-full wealthmanagement'>
                <header className="banner">
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/services'>Services</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>Wealth Management</h1>
                        </div>
                    </div>
                </header>
                <div className="details">
                    <div className="container-fluid">
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            <p>
                                At FSDH Merchant Bank, we listen to our clients to establish their financial goals,
                                then partner with them to develop bespoke wealth and investment management strategies,
                                as well as identify viable investment opportunities to help preserve and grow their wealth.
                            </p>
                            <p>
                                We combine timely and relevant advice with astute investment management practises to deliver superior service,
                                whilst providing seamless access to their investment portfolios to allow for monitoring and decision making.
                            </p>
                            <p>
                                Getting started is easy!  All you need to do is contact the Wealth Management Team by email at:
                            </p>
                            <p className='mailing'>
                                fi@fsdhgroup.com
                            </p>
                            <p className='mailing'>
                                Telephone: +234 (0) 1 2702885-6
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section-alt">
                    <div className="container-fluid">
                        <div className="row">
                            <StyleOne tag='services' serviceDesc='Investment Banking' bgcolor='dark-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                            <StyleOne tag='services' serviceDesc='Corporate Banking' bgcolor='light-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WealthManagement;